import getColor from "@insite/mobius/utilities/getColor";
import { cardListHeadingStyles } from "@waytek/Overrides/Components/CardListHeading";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

cardListHeadingStyles.headingContainer = {
    ...cardListHeadingStyles.headingContainer,
    css: css`
        &&& {
            border-bottom: 3px solid ${getColor(colorStrings.commonGlobalIndustrialTaupe)};
            padding-top: 20px;
            padding-bottom: 4px;

            & > div {
                width: calc(100% + 30px);
            }
        }
    `,
};

cardListHeadingStyles.headingTitle = {
    ...cardListHeadingStyles.headingTitle,
    as: "h2",
    variant: "h6",
    size: 18,
    css: css`
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.78;
        letter-spacing: normal;
        text-transform: none;
        margin: 0;
    `,
};

cardListHeadingStyles.viewAllLink = {
    ...cardListHeadingStyles.viewAllLink,
    css: css`
        justify-content: flex-end;

        a {
            flex-flow: row-reverse;

            span:nth-child(1) {
                margin-right: 0;
                margin-left: 9px;
            }
        }
    `,
};
